module.exports = __webpack_public_path__ + "img/pic04_index.e3cbb417.png";